import { Fragment, type ReactNode } from 'react';
import type { RichInline, RichTextValue } from '../richText';

function inline(list: RichInline[]): ReactNode[] {
  return list.map((x, i) => {
    let node: ReactNode = x.text;
    if (x.underline) node = <u>{node}</u>;
    if (x.italic) node = <em>{node}</em>;
    if (x.bold) node = <strong>{node}</strong>;
    if (x.link) {
      node = (
        <a className="govuk-link" href={x.link} rel="noopener noreferrer">
          {node}
        </a>
      );
    }
    return <Fragment key={i}>{node}</Fragment>;
  });
}

/** A RICH_TEXT answer as text (summaries, read-only forms): paragraphs and lists with their formatting. */
export function RichTextView({ value }: { value: RichTextValue }) {
  return (
    <div className="app-rich-text">
      {value.blocks.map((b, i) => {
        if (b.type === 'paragraph') {
          return (
            <p className="govuk-body" key={i}>
              {inline(b.content)}
            </p>
          );
        }
        const items = b.items.map((item, j) => <li key={j}>{inline(item)}</li>);
        return b.type === 'bulletList' ? (
          <ul className="govuk-list govuk-list--bullet" key={i}>
            {items}
          </ul>
        ) : (
          <ol className="govuk-list govuk-list--number" key={i}>
            {items}
          </ol>
        );
      })}
    </div>
  );
}
